function fireOutbrainPageView() {
  const advId = this.getOcodeValue('component.PartialPageViewPixel.outbrainPixelId');
  if (this.win.obApi) {
    const toArray = function (object) {
      return Object.prototype.toString.call(object) === '[object Array]' ? object : [object];
    };

    this.win.obApi.marketerId = toArray(this.win.obApi.marketerId).concat(toArray(advId));
    return;
  }

  var api = (this.win.obApi = function() {
    api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments);
  });
  api.version = '1.1';
  api.loaded = true;
  api.marketerId = advId;
  api.queue = [];
  const tag = this.doc.createElement('script');
  tag.async = true;
  tag.src = '//amplify.outbrain.com/cp/obtp.js';
  tag.type = 'text/javascript';
  const script = this.doc.getElementsByTagName('script')[0];
  script.parentNode.insertBefore(tag, script);
  this.win.obApi('track', 'PAGE_VIEW');
}

function fireOutbrainConversion() {
  const overridePrefix = this.getOverridePrefix();
  const id = this.getOcodeValue(`${overridePrefix}.outbrainPixelId`);
  const eventName = this.getOcodeValue(`${overridePrefix}.outbrainEventName`) || 'CSClickOutYahoo';

  if (!this.win.obApi) {
    this.fireOutbrainPageView();
  }
  this.win.obApi('track', eventName);
}

module.exports = {
  fireOutbrainPageView,
  fireOutbrainConversion,
};
